﻿import document from 'document';

export const isMobile = () => {
    const config = {
        smallScreen: 767 // breakpoint matches that in _break-points.scss file
    };

    return document.documentElement.clientWidth < config.smallScreen;
};